/**
 *
 * AuthCallToActionModal
 *
 */

import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  makeSelectAuth,
  makeSelectAuthCTAModalStatus,
} from 'containers/Auth/selectors';
import { hideAuthCTAModal } from 'containers/Auth/actions';
import ModalContent from './ModalContent';

const AuthCallToActionModal = () => {
  const dispatch = useDispatch();
  const auth = useSelector(makeSelectAuth());
  const status = useSelector(makeSelectAuthCTAModalStatus());

  useEffect(() => {
    if (auth.isLoaded && !auth.isEmpty) {
      dispatch(hideAuthCTAModal());
    }
  }, [auth]);

  if (!status) return null;

  return <ModalContent />;
};

export default AuthCallToActionModal;
